export default function (pluginsHandler) {
    return {
        name: 'default',
        rowSubNodesIf: 'isFolder',
        rowSubNodesShow: 'open',
        treeMixins: {
            props: {
                defaultPropertyTitleKey: {
                    type: String,
                    default: 'name'
                },
                defaultSubItemsKey: {
                    type: String,
                    default: 'children'
                },
                defaultPropertyIdKey: {
                    type: String,
                    default: 'id'
                },
                defaultMaxLevels: {
                    type: Number,
                    default: 1
                }
            },
            methods: {
                defaultFindElementsByIDs(ids) {
                    let self = this;
                    if (!Array.isArray(ids))
                        ids = [ids]
                    let result = []

                    function doSearch(root) {
                        root.forEach(child => {
                            if (child.rowItem) {
                                let isFound = !!ids.find(id => {
                                    return id === child.rowItem[self.defaultPropertyIdKey]
                                })

                                if (isFound) {
                                    result.push(child)
                                }
                            }

                            if (child.$children.length > 0) {
                                doSearch(child.$children)
                            }
                        })
                    }

                    doSearch(this.$children)

                    return result
                }
            }
        },
        treeRowMixins: {
            data: function () {
                return {
                    open: true
                }
            }
        },
        processData(data, tree) {
            var id = 0
            function appendData(source) {
                Object.keys(source).forEach((key) => {                    
                    Vue.set(source[key].internal, '_id', ++id)
                    if (source[key][tree.defaultSubItemsKey]) {
                        appendData(source[key][tree.defaultSubItemsKey], id)
                    }
                    
                })

                return data;
            }
            appendData(data);
            return data;
        }
    }
}
